import { render, staticRenderFns } from "./accountLayout.vue?vue&type=template&id=e54cf32a&scoped=true&"
import script from "./accountLayout.vue?vue&type=script&lang=js&"
export * from "./accountLayout.vue?vue&type=script&lang=js&"
import style0 from "./accountLayout.vue?vue&type=style&index=0&id=e54cf32a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54cf32a",
  null
  
)

export default component.exports